import { atomWithReset } from 'jotai/utils'

import { type Brand } from '~/hooks/useSurveyForSettingsQuery'

type DialogInfo =
  | {
      dialogType: 'create'
      brand?: undefined
    }
  | {
      dialogType: 'delete' | 'update'
      brand: Brand
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
